import { createContext, useContext, useEffect, useState } from 'react';
import { academicUnitsTypes } from '../../utils/headerData';
import { IconChalkboard, IconMicroscope, IconSchool } from '@tabler/icons-react';
import { useAppContext } from '../AppState/AppContext';

const HeaderContext = createContext()

export const useHeaderContext = () => {
   return useContext(HeaderContext)
}

export const HeaderProvider = ({ children }) => {
   const { specialtiesInfo, openSource, isMobile, jsonTexts } = useAppContext()
   const [toggleBurger, setToggleBurger] = useState(false)
   const [isMegaMenu, setIsMegaMenu] = useState(false)
   const [scrollValue, setScrollValue] = useState(0)

   useEffect(() => {
      const header = document.querySelector('.navbar-toggle-active')
      const isMenuActive = header

      if (isMenuActive) {
         document.body.style.overflowY = 'hidden';
      } else {
         document.body.style.overflowY = 'auto';
      }
      window.addEventListener('scroll', changeHeaderBkg)
      return () => window.removeEventListener('scroll', changeHeaderBkg)
   }, [toggleBurger])

   const changeHeaderBkg = () => {
      setScrollValue(window.scrollY)
   }

   const onMouseEnterMenu = () => {
      !isMobile &&
         setIsMegaMenu(true)
   }
   const onMouseLeaveMenu = () => {
      !isMobile &&
         setIsMegaMenu(false)
   }

   const onClickMegaMenu = () => {
      isMobile &&
         setIsMegaMenu(!isMegaMenu)
   }

   const isScrolling = scrollValue >= 1

   const { tabsScheme } = jsonTexts.header.megaMenu
   const {
      openSource: openSourceTab,
      academicUnitsTypes: academicUnitsTypesTab,
      specialtiesInfo: specialtiesInfoTab
   } = tabsScheme

   const INFO_MEGA_MENU = [
      (openSourceTab.show && {
         to: openSourceTab.redirectTo,
         icon: < IconChalkboard class='mega-menu-filter-icon' />,
         description: openSourceTab.description,
         title: openSourceTab.title,
         value: openSourceTab.title,
         cardVariant: 'CardPhotoBg',
         data: openSource?.data
      }),
      (academicUnitsTypesTab.show && {
         to: academicUnitsTypesTab.redirectTo,
         icon: < IconSchool class='mega-menu-filter-icon' />,
         description: academicUnitsTypesTab.description,
         title: academicUnitsTypesTab.title,
         value: academicUnitsTypesTab.title,
         data: academicUnitsTypes,
         cardVariant: 'MegaMenuIconCard'
      }),
      (specialtiesInfoTab.show && {
         to: specialtiesInfoTab.redirectTo,
         icon: < IconMicroscope class='mega-menu-filter-icon' />,
         description: specialtiesInfoTab.description,
         title: specialtiesInfoTab.title,
         value: specialtiesInfoTab.title,
         data: specialtiesInfo?.data,
         cardVariant: 'MegaMenuList'
      })
   ].filter(Boolean)

   return (
      <HeaderContext.Provider value={{
         toggleBurger,
         setToggleBurger,
         isMegaMenu,
         scrollValue,
         changeHeaderBkg,
         onMouseEnterMenu,
         onMouseLeaveMenu,
         onClickMegaMenu,
         isScrolling,
         INFO_MEGA_MENU
      }}>
         {children}
      </HeaderContext.Provider>
   )
}